function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["affixRight", "affixLeft", "id", "className", "defaultValue", "disabled", "hasError", "hasPortal", "hasWarning", "hidden", "iconOnly", "inline", "onDateChange", "onSubmit", "onCancel", "onEdit", "label", "mask", "range", "required", "readOnly", "unavailableDates", "value", "isInverse", "portalContainer", "portalClassName", "isActiveOnFocus", "utils", "selectRange", "selectWeek", "minDate", "maxDate", "openToDate"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import nodeOfType from '../../utilities/types-of-node';
import { createFocusTrap } from 'focus-trap';
import InverseContext from '../../utilities/inverse-context';
import DateField from '../date-field';
import Calendar from '../calendar';
import Button from '../button/Button';
import Modal from '../modal';
import Type from '../type';
import DateString from '../../utilities/date-string';
import DateUtils from '../../utilities/date-utils';
import generateID from '../../utilities/generateID';
import CONSTANTS from '../../appConstants';
import StyledDatePicker from './date-picker.styles';
import StyledDatePickerCalendar from './styles/date-picker.calendar.styles';
import StyledDatePickerInput from './styles/date-picker.input.styles';
import StyledDatePickerRangeTitle from './styles/date-picker.range-title.styles';
import { DatePickerContext } from './context/date-picker.context';
var propTypes = {
  /** add affix items to the right of an input field. {{icon: String, text: String, onButtonClick: Function, inverse: Boolean}[]} */
  affixRight: PropTypes.array,
  /** add affix items to the left of an input field. {{icon: String, text: String, onButtonClick: Function, inverse: Boolean}[]} */
  affixLeft: PropTypes.array,
  /** Default value */
  defaultValue: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]))]),
  /** Specifies if the datepicker is disabled. */
  disabled: PropTypes.bool,
  /** Renders the datepicker in an inline format */
  inline: PropTypes.bool,
  /** See DateField organism for supported values. */
  mask: PropTypes.oneOf(['0000', '00/00', '00-00', '00/0000', '00-0000', '00/00/0000', '00-00-0000', '0000/00/00', '0000-00-00']),
  /** Callback fired whenever the value of the datepicker changes. Changes are triggered by the user typing into the field or by the user selecting a date from the datepicker. This callback receives a `details` parameter which contains a `date` property, a date object representing the selected date, and a `value` property, a string representation of the selected date. */
  onDateChange: PropTypes.func,
  /** Callback fired when the 'Ok' button within the datepicker's footer is clicked. This callback receives the same parameter as the `onDateChange` callback. */
  onSubmit: PropTypes.func,
  /** Callback fired when the 'Cancel' button within the datepicker's footer is clicked. */
  onCancel: PropTypes.func,
  /** Callback fired when edit button is clicked(inline). */
  onEdit: PropTypes.func,
  /** @ignore An array containing two date objects representing a date range. */
  range: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  /** The minimum date that can be selected. Allows date objects and valid date strings. */
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  /** The maximum date that can be selected. Allows date objects and valid date strings. */
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  /** The date at which to open the calendar when there is no value. Allows date objects and valid date strings. */
  openToDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  /** An array containing date objects that represent unavailable dates on the calendar. */
  unavailableDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  /** Specifies the form fields label text. */
  label: PropTypes.oneOfType([PropTypes.string, nodeOfType([Type])]),
  /** A date string representing the default selected date. Must be in the following format: MM.DD.YYYY, MM/DD/YYYY, MM-DD-YYYY, MMDDYYYY or a JavaScript `Date` object. */
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]))]),
  /** Specifies whether the datepicker is a required field. */
  required: PropTypes.bool,
  /** Makes date picker field read only */
  readOnly: PropTypes.bool,
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Error state. */
  hasError: PropTypes.bool,
  /** Render the calendar in a react portal */
  hasPortal: PropTypes.bool,
  /** Warning state. */
  hasWarning: PropTypes.bool,
  /** Makes datepicker hidden */
  hidden: PropTypes.bool,
  /** Applies readOnly to the input so that only the calendar controls the value. */
  iconOnly: PropTypes.bool,
  /** Component design with dark background. */
  isInverse: PropTypes.oneOf(['auto', true, false]),
  /** datepicker Id */
  id: PropTypes.string,
  /** Portal container */
  portalContainer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Add custom CSS classes to Portal Container. */
  portalClassName: PropTypes.string,
  /** Show/Hide the calendar on focus. It will be always hidden for iconOnly and/or readOnly datepicker */
  isActiveOnFocus: PropTypes.bool,
  /** Add utility props for styling */
  utils: PropTypes.object,
  /** Select a range of dates */
  selectRange: PropTypes.bool,
  /** Select a week of dates */
  selectWeek: PropTypes.bool
};
var defaultProps = {
  affixRight: [],
  affixLeft: [],
  id: '',
  defaultValue: '',
  disabled: false,
  inline: false,
  mask: '00/00/0000',
  onDateChange: function onDateChange() {},
  onSubmit: function onSubmit() {},
  onCancel: function onCancel() {},
  onEdit: function onEdit() {},
  range: null,
  minDate: null,
  maxDate: null,
  openToDate: null,
  unavailableDates: [],
  label: '',
  value: '',
  required: false,
  readOnly: false,
  className: '',
  hasError: false,
  hasPortal: false,
  hasWarning: false,
  hidden: false,
  iconOnly: false,
  isInverse: 'auto',
  portalContainer: null,
  portalClassName: '',
  isActiveOnFocus: false,
  utils: {},
  selectRange: false,
  selectWeek: false
};

/** Format date for title */
var _prettyDate = function prettyDate(inputDate, shortMonthName, highlightIndex) {
  // If input is an array (for range selection)
  if (Array.isArray(inputDate)) {
    // If either dates are invalid, return 'Select Date' as title
    if (inputDate.find(function (value) {
      return !DateUtils.isValidDate(value);
    })) {
      return 'Select Date';
    }
    return /*#__PURE__*/React.createElement(StyledDatePickerRangeTitle, {
      highlightIndex: highlightIndex
    }, /*#__PURE__*/React.createElement(Type, {
      size: "lg",
      weight: "semibold"
    }, _prettyDate(inputDate[0], true)), " \u2014 ", /*#__PURE__*/React.createElement(Type, {
      size: "lg",
      weight: "semibold"
    }, inputDate[1] && _prettyDate(inputDate[1], true)));
  }
  if (!DateUtils.isValidDate(inputDate)) {
    return 'Select Date';
  }
  var date = inputDate.getDate();
  var month = inputDate.getMonth();
  var year = inputDate.getFullYear();
  return "".concat(CONSTANTS.MONTHS[month][shortMonthName ? 1 : 0], " ").concat(date, ", ").concat(year);
};
var getMonthYear = function getMonthYear(month, year) {
  return {
    useMonth: isNaN(month) ? now.getMonth() : month,
    useYear: isNaN(year) ? now.getFullYear() : year
  };
};

/** Removes date picker input field focus when inline */
var isNegativeTabIndex = function isNegativeTabIndex(inline) {
  return inline ? -1 : undefined;
};

/** Is selected date / range valid */
var isSelectionValid = function isSelectionValid(inputDate, selectRange, useRange) {
  var dateAsArray = [].concat(inputDate);
  // selecting a range requires 2 valid dates
  if (selectRange) {
    // update array to always be 2 items
    dateAsArray = [].concat(_toConsumableArray(dateAsArray), [undefined]).slice(0, 2);
  }
  return dateAsArray.every(function (date) {
    if (DateUtils.isDate(useRange[0]) && date && !DateUtils.dateIsInRange(date, [useRange[0], null])) {
      return false;
    }
    if (DateUtils.isDate(useRange[1]) && date && !DateUtils.dateIsInRange(date, [null, useRange[1]])) {
      return false;
    }
    return DateUtils.isValidDate(date);
  });
};

/**
 * @description input string value(s) and convert to a Date. only return valid dates for the **UI date picker**
 * @param {(String | Date[] | Date)} value
 * @param {boolean} selectRange
 * @returns {(Date[] | Date | undefined)}
 */
var stringValueToDate = function stringValueToDate(value, selectRange) {
  var dirtyDateStringRegEx = /^([0-9]{2}[0-9,\/,.,-]{6}[0-9]{2} — [0-9]{2}[0-9,\/,.,-]{6}[0-9]{2}|[0-9]{2}[0-9,\/,.,-]{6}[0-9]{2})$/;
  if (typeof value === 'string' && value.match(dirtyDateStringRegEx)) {
    var date;
    if (selectRange) {
      // return array for state.date if range
      var dateObjects = value.split(' — ').map(function (val) {
        return DateUtils.isValidDate(new Date(val)) && new Date(val);
      });
      var validDates = dateObjects.filter(function (val) {
        return !!val;
      })[0];
      if (validDates) {
        date = dateObjects;
      }
    } else {
      date = DateUtils.isValidDate(new Date(value)) && new Date(value);
    }
    return date;
  } else {
    return value;
  }
};

/**
 * @description handle value prop
 * @param {(String | Date[] | Date)} nextValue
 * @param {boolean} selectWeek
 * @param {string} mask
 * @param {Date[]} range
 * @param {boolean} selectRange
 * @returns {{}}
 */
var valuePropHandler = function valuePropHandler(nextValue, selectWeek, mask, range, selectRange) {
  var resp = {};
  var nextValueDate = stringValueToDate(nextValue, selectRange);
  if (!Array.isArray(nextValueDate)) {
    resp.date = DateString.fromUserToDate(nextValueDate, DateField.maskToDateStringFormat(mask), range);
  } else {
    resp.date = nextValueDate.map(function (val) {
      return DateString.fromUserToDate(val, DateField.maskToDateStringFormat(mask), range);
    });
  }
  if (selectWeek) {
    // return week with start / end dates
    var startOfWeek = new Date(nextValueDate);
    startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
    var endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);
    resp.value = [startOfWeek, endOfWeek];
    resp.week = [startOfWeek, endOfWeek];
  } else {
    resp.value = [].concat(nextValueDate);
  }
  resp.value = resp.value.map(function (val) {
    return DateString.fromUserFromDate(val, DateField.maskToDateStringFormat(mask));
  }).join(" \u2014 ");
  return resp;
};
var renderCalendar = function renderCalendar(calendarProps) {
  var calendar = calendarProps.calendar,
    datepickerId = calendarProps.datepickerId,
    hasPortal = calendarProps.hasPortal,
    month = calendarProps.month,
    year = calendarProps.year,
    date = calendarProps.date,
    dispatchOnCancel = calendarProps.dispatchOnCancel,
    dispatchOnSubmit = calendarProps.dispatchOnSubmit,
    dispatchOnMouseEnter = calendarProps.dispatchOnMouseEnter,
    dispatchOnMouseLeave = calendarProps.dispatchOnMouseLeave,
    isActive = calendarProps.isActive,
    inline = calendarProps.inline,
    inlineEditBtnRef = calendarProps.inlineEditBtnRef,
    range = calendarProps.range,
    minDate = calendarProps.minDate,
    maxDate = calendarProps.maxDate,
    unavailableDates = calendarProps.unavailableDates,
    portalContainer = calendarProps.portalContainer,
    dispatchOnCalendarDayClick = calendarProps.dispatchOnCalendarDayClick,
    portalClassName = calendarProps.portalClassName,
    label = calendarProps.label,
    affixBtnRef = calendarProps.affixBtnRef,
    selectRange = calendarProps.selectRange,
    selectWeek = calendarProps.selectWeek,
    nextChangeIndex = calendarProps.nextChangeIndex,
    title = calendarProps.title,
    week = calendarProps.week,
    value = calendarProps.value;
  var useRange = range || [minDate, maxDate];
  var _getMonthYear = getMonthYear(month, year),
    useMonth = _getMonthYear.useMonth,
    useYear = _getMonthYear.useYear;
  return /*#__PURE__*/React.createElement(Modal, {
    hasPortal: hasPortal,
    hideTrigger: true,
    isActive: isActive,
    id: "".concat(datepickerId, "-modal"),
    onClose: function onClose() {
      dispatchOnCancel(isActive, value, useRange, selectRange);
    },
    portalClassName: portalClassName,
    portalContainer: portalContainer,
    size: "xs",
    setOnCloseFocus: inline ? inlineEditBtnRef : affixBtnRef
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    isInverse: true,
    size: selectRange || selectWeek ? 'md' : 'lg',
    subTitle: label,
    title: _prettyDate(title, false, selectRange ? nextChangeIndex : null),
    variant: "success"
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    isFlushPadding: true,
    variant: "cool-gray"
  }, /*#__PURE__*/React.createElement(StyledDatePickerCalendar, {
    ref: calendar
  }, /*#__PURE__*/React.createElement(DatePickerContext.Provider, {
    value: true
  }, /*#__PURE__*/React.createElement(Calendar, {
    id: datepickerId,
    month: useMonth,
    year: useYear,
    date: date,
    onMouseEnter: dispatchOnMouseEnter,
    onMouseLeave: dispatchOnMouseLeave,
    onDateChange: function onDateChange(resp, event) {
      dispatchOnCalendarDayClick(resp, event);
    },
    range: range,
    unavailableDates: unavailableDates,
    selectRange: selectRange,
    selectWeek: selectWeek,
    minDate: minDate,
    maxDate: maxDate
  })))), /*#__PURE__*/React.createElement(Modal.Footer, {
    hasBorder: false
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isActive && !isSelectionValid(date, selectRange, useRange),
    onClick: function onClick() {
      return dispatchOnSubmit({
        date: date,
        week: week
      });
    }
  }, "set"), /*#__PURE__*/React.createElement(Button, {
    variant: "muted",
    onClick: function onClick() {
      dispatchOnCancel(isActive, value, useRange, selectRange);
    }
  }, "close")));
};
var generateUtils = function generateUtils(inline) {
  return inline ? {
    flexDirection: 'row'
  } : {};
};
var setIsInverse = function setIsInverse(isInverseProp, context) {
  return isInverseProp !== 'auto' ? isInverseProp : context;
};
function monthYearHandler(now, useRange, openToDate) {
  var _useRange = _slicedToArray(useRange, 2),
    minDate = _useRange[0],
    maxDate = _useRange[1];
  if (openToDate) {
    return {
      month: openToDate.getMonth(),
      year: openToDate.getFullYear()
    };
  }
  if (minDate && minDate > now) {
    return {
      month: minDate.getMonth(),
      year: minDate.getFullYear()
    };
  }
  if (maxDate && maxDate < now) {
    return {
      month: maxDate.getMonth(),
      year: maxDate.getFullYear()
    };
  }
  return {
    month: now.getMonth(),
    year: now.getFullYear()
  };
}

/**
 * @ignore @description
 * ## DatePicker
 * The DatePicker component provides an input with an optional datepicker dialog that assists the user in selecting dates.
 *
 * @ignore @see Mesh: [DatePicker Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/forms-datepicker--default)
 *
 * @ignore @example
 * ```jsx
 * import { DatePicker } from 'mesh-component-library';
 *
 * <DatePicker label="Choose a Date" />;
 * ```
 */

var DatePicker = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var affixRight = props.affixRight,
    affixLeft = props.affixLeft,
    id = props.id,
    className = props.className,
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    hasError = props.hasError,
    hasPortal = props.hasPortal,
    hasWarning = props.hasWarning,
    hidden = props.hidden,
    iconOnly = props.iconOnly,
    inline = props.inline,
    onDateChange = props.onDateChange,
    onSubmit = props.onSubmit,
    onCancel = props.onCancel,
    onEdit = props.onEdit,
    label = props.label,
    mask = props.mask,
    range = props.range,
    required = props.required,
    readOnly = props.readOnly,
    unavailableDates = props.unavailableDates,
    value = props.value,
    isInverse = props.isInverse,
    portalContainer = props.portalContainer,
    portalClassName = props.portalClassName,
    isActiveOnFocus = props.isActiveOnFocus,
    utils = props.utils,
    selectRange = props.selectRange,
    selectWeek = props.selectWeek,
    minDate = props.minDate,
    maxDate = props.maxDate,
    openToDate = props.openToDate,
    other = _objectWithoutProperties(props, _excluded);
  var calendar = useRef();
  var affixBtnRef = useRef();
  var inlineEditBtnRef = useRef();
  var valueFromProp = defaultValue || value;
  var datepickerId = id || generateID('datepicker_');
  var now = new Date();
  var useRange = range || [DateUtils.toDate(minDate), DateUtils.toDate(maxDate)];
  var useIsInverse = setIsInverse(isInverse, React.useContext(InverseContext));
  var valueProps = valuePropHandler(valueFromProp, selectWeek, mask, useRange, selectRange);
  var initialMonthYear = monthYearHandler(now, useRange, DateUtils.toDate(openToDate));
  var _useState = useState(_objectSpread({
      date: null,
      focusTrap: null,
      isActive: false,
      month: initialMonthYear.month,
      nextChangeIndex: null,
      title: '',
      value: null,
      week: null,
      year: initialMonthYear.year
    }, valueProps)),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var updateState = function updateState(newState) {
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), newState);
    });
  };
  var open = function open() {
    return updateState({
      isActive: true
    });
  };
  var dispatchOnDateChange = function dispatchOnDateChange(details) {
    var dateAsArray = [].concat(details.date);
    if (!DateUtils.isDate(dateAsArray[0])) {
      onDateChange(details);
      return;
    }
    updateState({
      date: selectRange ? dateAsArray.filter(function (date) {
        return date !== undefined;
      }) : dateAsArray[0],
      value: details.value,
      // if selecting a week
      week: selectWeek ? valuePropHandler(details.value, selectWeek, mask, useRange, selectRange).week || state.week : state.week
    });
    onDateChange(details);
  };
  var dispatchOnCalendarDayClick = function dispatchOnCalendarDayClick(_ref, event) {
    var date = _ref.date,
      week = _ref.week;
    // function to get string from date
    var func = function func(e) {
      return DateString.fromDate(e, DateField.maskToDateStringFormat(mask));
    };
    // date / range / week as string
    var stringValue = Array.isArray(week || date) ? (week || date).map(function (d) {
      return func(d);
    }).join(" \u2014 ") : func(date);
    onDateChange({
      date: date,
      week: week,
      value: stringValue
    }, event);
    updateState({
      date: date,
      week: week
    });
  };
  var dispatchOnSubmit = function dispatchOnSubmit(_ref2) {
    var date = _ref2.date,
      week = _ref2.week;
    // function to get string from date
    var func = function func(e) {
      return DateString.fromDate(e, DateField.maskToDateStringFormat(mask));
    };
    // date / range / week as string
    var stringValue = Array.isArray(week || date) ? (week || date).map(function (d) {
      return func(d);
    }).join(" \u2014 ") : func(date);
    onSubmit({
      date: date,
      week: week,
      value: stringValue
    });
    updateState({
      date: date,
      isActive: false,
      week: week,
      value: stringValue
    });
  };
  var dispatchOnCancel = function dispatchOnCancel(isActive, nextValue, isUseRange, isSelectRange) {
    if (isActive) {
      updateState(_objectSpread(_objectSpread({}, valuePropHandler(state.value === null ? value : state.value, selectWeek, mask, isUseRange, isSelectRange)), {}, {
        isActive: false
      }));
      onCancel();
    }
  };
  var dispatchOnClick = function dispatchOnClick() {
    open();
    onEdit();
  };
  var dispatchOnMouseEnter = function dispatchOnMouseEnter(_ref3) {
    var date = _ref3.date,
      week = _ref3.week;
    // update title to hovered date / week range
    if (!selectRange && !selectWeek) {
      return;
    }
    var nextChangeIndex = 0;
    if (Array.isArray(state.date) && Array.isArray(date)) {
      if (state.date[0] === date[0] && state.date[1] !== date[1]) {
        nextChangeIndex = 1;
      }
    }
    updateState({
      nextChangeIndex: nextChangeIndex,
      title: week || date
    });
  };
  var dispatchOnMouseLeave = function dispatchOnMouseLeave() {
    updateState({
      nextChangeIndex: null,
      title: state.week || state.date
    });
  };
  useEffect(function () {
    updateState({
      focusTrap: createFocusTrap(calendar.current, {
        escapeDeactivates: false,
        fallbackFocus: calendar.current
      })
    });
  }, [calendar]);
  useEffect(function () {
    updateState(_objectSpread({}, valuePropHandler(value === null ? state.value : value, selectWeek, mask, useRange, selectRange)));
  }, [value]);
  useEffect(function () {
    if ((minDate || maxDate || openToDate) && !value) {
      updateState({
        title: state.week || state.date,
        month: initialMonthYear.month,
        year: initialMonthYear.year
      });
    }
  }, [minDate, maxDate, openToDate, value]);
  useEffect(function () {
    var dateAsArray = [].concat(state.date);
    if (!DateUtils.isDate(dateAsArray[0])) {
      updateState({
        title: '',
        month: initialMonthYear.month,
        year: initialMonthYear.year
      });
      return;
    }
    // entered date(s) is before min date (if applicable)
    if (DateUtils.isDate(useRange[0]) && dateAsArray.some(function (date) {
      return !DateUtils.isDate(date) || !DateUtils.dateIsInRange(date, [useRange[0], null]);
    })) {
      updateState({
        title: state.week || state.date,
        // set date to null, and month and year to min date value
        month: useRange[0].getMonth(),
        year: useRange[0].getFullYear()
      });
    }
    // entered date(s) is after max date (if applicable)
    else if (DateUtils.isDate(useRange[1]) && dateAsArray.some(function (date) {
      return !DateUtils.isDate(date) || !DateUtils.dateIsInRange(date, [null, useRange[1]]);
    })) {
      updateState({
        title: state.week || state.date,
        // set date to null, and month and year to max date value
        month: useRange[1].getMonth(),
        year: useRange[1].getFullYear()
      });
    }
    // entered date(s) is valid (in range if applicable)
    else {
      updateState({
        title: state.week || state.date,
        month: dateAsArray[0].getMonth(),
        year: dateAsArray[0].getFullYear()
      });
    }
  }, [state.date, state.week]);
  var calendarProps = {
    affixRight: affixRight,
    affixLeft: affixLeft,
    calendar: calendar,
    datepickerId: datepickerId,
    hasPortal: hasPortal,
    month: state.month,
    year: state.year,
    date: state.date,
    dispatchOnCancel: dispatchOnCancel,
    dispatchOnSubmit: dispatchOnSubmit,
    dispatchOnMouseEnter: dispatchOnMouseEnter,
    dispatchOnMouseLeave: dispatchOnMouseLeave,
    dispatchOnCalendarDayClick: dispatchOnCalendarDayClick,
    isActive: state.isActive,
    inline: inline,
    range: range,
    minDate: minDate,
    maxDate: maxDate,
    unavailableDates: unavailableDates,
    portalContainer: portalContainer,
    portalClassName: portalClassName,
    updateState: updateState,
    label: label,
    affixBtnRef: affixBtnRef,
    inlineEditBtnRef: inlineEditBtnRef,
    selectRange: selectRange,
    selectWeek: selectWeek,
    title: state.title,
    week: state.week,
    nextChangeIndex: state.nextChangeIndex,
    value: state.value,
    mask: mask
  };
  return /*#__PURE__*/React.createElement(StyledDatePicker, {
    hasError: hasError,
    hasLabel: !!label,
    hasWarning: hasWarning,
    isInline: inline,
    isInverse: useIsInverse,
    className: className,
    hidden: hidden,
    utils: utils
  }, /*#__PURE__*/React.createElement(StyledDatePickerInput, null, /*#__PURE__*/React.createElement(DateField, _extends({}, other, {
    id: datepickerId,
    actionOnly: iconOnly,
    disabled: disabled,
    readOnly: inline || readOnly,
    hasError: hasError,
    hasWarning: hasWarning,
    label: label,
    value: state.value,
    mask: mask,
    onDateChange: dispatchOnDateChange,
    required: required,
    isInverse: useIsInverse,
    isDateRange: selectRange || selectWeek,
    affixLeft: affixLeft
  }, !inline && {
    affixRight: [].concat(_toConsumableArray(affixRight), [{
      onButtonClick: dispatchOnClick,
      icon: 'calendar',
      content: 'Open Date Picker',
      ref: affixBtnRef,
      disabled: disabled
    }])
  }, {
    tabIndex: isNegativeTabIndex(inline),
    utils: generateUtils(inline)
  }, !readOnly && isActiveOnFocus && {
    onFocus: dispatchOnClick
  }, {
    ref: forwardedRef
  })), inline && /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Edit Date Picker",
    id: "".concat(datepickerId, "-edit-btn"),
    isInverse: useIsInverse,
    onClick: dispatchOnClick,
    variant: "phony",
    ref: inlineEditBtnRef
  }, "Edit")), /*#__PURE__*/React.createElement(InverseContext.Provider, {
    value: false
  }, renderCalendar(calendarProps)));
});
DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;
DatePicker.displayName = 'DatePicker';
export default DatePicker;